import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {AuthGuard} from './pages/admin/auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch : 'full',
    redirectTo : 'subscriber'
  },
  {
    path: 'subscriber',
    loadChildren: () => import('./pages/subscriber/subscriber.module').then( m => m.SubscriberModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./pages/admin/admin.module').then( m => m.AdminModule),
    canActivate : [AuthGuard],
    data : {
      role: 'ROLE_ADMIN'
    }
  },
  {
    path: 'expert',
    loadChildren: () => import('./pages/expert/expert.module').then( m => m.ExpertModule),
    canActivate : [AuthGuard],
    data : {
      role: 'ROLE_EXPERT'
    }
  },
  {
    path: 'video-chat',
    loadChildren: () => import('./pages/subscriber/video-chat/video-chat.module').then( m => m.VideoChatPageModule),
    canActivate : [AuthGuard],
    data : {
      role: 'ROLE_SUBSCRIBER'
    }
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
